// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"184972d4","540":"c39af816"}[chunkId] + ".chunk.js";
};